<template>
  <div class="catalog-product-modal">
    <CatalogProductDetail />
    <div class="catalog-product-modal-controls">
      <span v-if="prevProduct" class="catalog-product-modal__prev" @click="handlerShowPrevProduct">
        <DefSwiperButtonPrev />
        {{ messages?.previousProduct }}
      </span>
      <span
        v-if="nextProduct || +pagination.pageNumber + 1 <= +pagination.pageCount"
        class="catalog-product-modal__next"
        @click="handlerShowNextProduct"
      >
        {{ messages?.nextProduct }}
        <DefSwiperButtonNext />
      </span>
    </div>
    <QuickViewForm :data-layer="dataLayer" />
  </div>
</template>

<script lang="ts" setup>
import QuickViewForm from '@components/forms/QuickViewForm.vue';

import useModal from '@use/useModal/useModal';
import CatalogProductDetail from '@components/Catalog/CatalogProductDetail/CatalogProductDetail.vue';
import { useStore } from '@/store';
import { useRoute, useRouter } from 'vue-router';
import { computed } from 'vue';
import DefSwiperButtonNext from '@components/Def/DefSwiper/DefSwiperButtonNext.vue';
import DefSwiperButtonPrev from '@components/Def/DefSwiper/DefSwiperButtonPrev.vue';

const route = useRoute();
const router = useRouter();

const modal = useModal();
const props = defineProps(['dataLayer']);

const { state, commit, dispatch } = useStore();

const product = computed(() => state.product.data.product);
const pagination = computed(() => state.catalog.data.catalogSectionList.pagination);
const catalogItems = computed(() => state.catalog.data.catalogSectionList.items);
const messages = computed(() => state.product.data.messages);
const productIndex = computed(() =>
  catalogItems.value.findIndex(
    (el) => el?.offer?.id === product.value?.offer?.id || el?.id === product.value?.id
  )
);

const nextProduct = computed(() => catalogItems.value[productIndex.value + 1]);
const prevProduct = computed(() => catalogItems.value[productIndex.value - 1]);

const handlerShowPrevProduct = async () => {
  try {
    commit('global/loaderStart');
    if (prevProduct.value) {
      const { status, data } = await axios.get(prevProduct.value.detailPage, {
        params: { api: 'Y' },
      });

      commit('product/setState', data);
    }
  } catch (err) {
    console.error(err);
  } finally {
    commit('global/loaderStop');
  }
};
const handlerShowNextProduct = async () => {
  try {
    commit('global/loaderStart');

    if (!nextProduct.value && +pagination.value.pageNumber + 1 <= +pagination.value.pageCount) {
      const { pageNumber, pagingKey } = pagination.value;

      const query = {
        ...route.query,
        [pagingKey]: +pageNumber + 1,
      };

      await router.replace({ path: route.path, query });

      await dispatch('catalog/getMoreItems', route.fullPath);
    }

    if (nextProduct.value) {
      const { status, data } = await axios.get(nextProduct.value.detailPage, {
        params: { api: 'Y' },
      });

      commit('product/setState', data);
    }
  } catch (err) {
    console.error(err);
  } finally {
    commit('global/loaderStop');
  }
};
</script>

<style lang="scss" scoped>
.catalog-product-modal-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  :deep(.def-swiper-button-prev) {
    margin-right: 12px;
  }
  :deep(.def-swiper-button-next) {
    margin-left: 12px;
  }
}
.catalog-product-modal {
  &__prev {
    display: flex;
    align-items: center;
    cursor: pointer;
    color: var(--color-main);
    transition: 2s linear color;
    &:hover {
      color: var(--color-dark-grey);
    }
  }
  &__next {
    display: flex;
    align-items: center;
    margin-left: auto;
    cursor: pointer;
    color: var(--color-main);
    transition: 2s linear color;
    &:hover {
      color: var(--color-dark-grey);
    }
  }
}
</style>
